"use client";

import { cn } from "@/lib/utils";
import { ReviewStars } from "./ReviewStars";

const GOOGLE_LOGO = "/get-started/google.svg";

export function ReviewsRow({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img src={GOOGLE_LOGO} alt="Google" className="h-6 w-auto" />
      <ReviewStars rating={4.5} className="h-[26px] w-[112px] shrink-0" />
      <span className="font-suisse-intl text-lg leading-4 text-white">4.5/5 Reviews</span>
    </div>
  );
}
